export const whenOnline = () => {
  if (window.navigator.onLine) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    const handleOnline = () => {
      window.removeEventListener('online', handleOnline);
      resolve();
    };
    window.addEventListener('online', handleOnline);
  });
};
